<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col align-self="center" cols="12" justify="center" style="max-width: 600px;">
        <h1 v-if="!user.attributes.email_verified" class="mb-5">Verifiziere deine E-Mail Adresse</h1>
        <h1 v-else>Deine E-Mail Adresse ist bereits verifiziert</h1>
        <p v-if="!user.attributes.email_verified">Nachdem du deine E-Mail Adresse über
          <span style="font-style: italic;">Profil verwalten</span>
          geändert hast, musst du diese verifizieren. Hierzu haben wir dir eine E-Mail an
          <span class="email">{{ user.attributes.email }}</span>
          mit einem Verifikationscode geschickt.<br/>
          Trage ihn hier in das Formular ein. Sollte die Gültigkeitsdauer des Codes bereits überschritten sein, kannst
          du dir einfach einen neuen zusenden lassen.</p>

        <v-form v-if="!user.attributes.email_verified" v-model="valid">
          <v-text-field v-model="mailVerifyCode"
                        :rules="[ v => !!v || 'Bitte Verifikationscode eintragen']"
                        class="mb-5"
                        label="Verifikationscode"
                        style="max-width: 250px;"/>
          <v-btn :disabled="user.attributes.email_verified || !valid"
                 class="mr-5"
                 @click="verifyMailCode">
            <v-icon class="mr-3">icon-check-ellipse</v-icon>
            Code prüfen
          </v-btn>
          <v-btn :disabled="user.attributes.email_verified"
                 @click="resendMailCode">
            <v-icon class="mr-3">icon-refresh</v-icon>
            neuen Code zusenden
          </v-btn>
        </v-form>

        <div v-if="successMsg" class="mt-5">
          <p>{{ successMsg }}</p>
          <v-btn :to="{ name: 'myFinHub' }" text>weiter zum Dashboard</v-btn>
        </div>

        <v-btn v-if="!successMsg && user.attributes.email_verified"
               :to="{ name: 'myFinHub' }"
               class="mt-5"
               text>
          weiter zum Dashboard
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: 'FinVerifyEmail',
  components: {},
  props: {
    code: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      valid: false,
      mailVerifyCode: null,
      successMsg: '',
    }
  },
  computed: mapGetters('auth', ['profile', 'user']),
  methods: {
    async verifyMailCode() {
      if (!this.user.attributes.email_verified) {
        try {
          await this.$Amplify.Auth.verifyCurrentUserAttributeSubmit("email", this.mailVerifyCode.trim())

          await this.$store.dispatch('auth/fetchUser')

          this.successMsg = 'Deine neue E-Mail Adresse wurde erfolgreich verifiziert.'
        } catch (error) {
          console.log("error checking mail change verifikation code", this.mailVerifyCode, error)
          this.$toasted.global.finToast({
            message: 'Bei der Verifikation deines Codes trat ein Fehler auf. Versuche es bitte erneut oder lasse dir einen neuen Code zusenden.',
            type: 'error'
          })
        }
      }
    },
    async resendMailCode() {
      if (!this.user.attributes.email_verified) {
        try {
          await this.$Amplify.Auth.verifyCurrentUserAttribute("email")
          this.$toasted.global.finToast({
            message: 'Es wurde ein neuer Verifikationscode an deine E-Mail Adresse gesendet.',
            type: 'success'
          })
        } catch (error) {
          console.log("error resending mail verifikation code", error)
          this.$toasted.global.finToast({
            message: 'Beim Zusenden deines neuen Verifikationscodes trat ein Fehler auf. Lade die Seite erneut und wiederhole die Aktion gegebenenfalls.',
            type: 'error'
          })
        }
      }
    }
  },
  mounted() {
    const code = this.$route.query.code

    if (code) {
      this.mailVerifyCode = code
      this.verifyMailCode()
    }
  }
}
</script>

<style lang="scss" scoped>
.email {
  color: $fin-color-primary-dark;
  font-style: italic;
  font-weight: bold;
}
</style>
